<form [formGroup]="formGroup" id="step1Form">
  <div class="step1-form-container">
    <div class="row">
      <div class="nowrap-container">
        <div *ngIf="controls.name as name" class="standard-form-field name-field required-field">
          <label [class.invalid]="name.touched && name.invalid" for="applicantName">
            {{ 'PERSONAL_DATA_FORM.NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="name.touched && name.invalid ? 'true' : null"
              [attr.aria-describedby]="
                name.touched && name.invalid ? 'applicantNameError applicantNameTooltip' : 'applicantNameTooltip'
              "
              [formControl]="name" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.NAME.TOOLTIP' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="name.touched && name.invalid" id="applicantNameError">
              {{ name.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="controls.previousName as previousName" class="standard-form-field previousName-field">
          <label for="applicantPreviousName" [class.invalid]="previousName.touched && previousName.invalid">
            {{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantPreviousName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-NAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="previousName.touched && previousName.invalid ? 'true' : null"
              [attr.aria-describedby]="
                previousName.touched && previousName.invalid
                  ? 'applicantPreviousNameError applicantPreviousNameTooltip'
                  : 'applicantPreviousNameTooltip'
              "
              [formControl]="previousName" />
            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantPreviousNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="previousName.touched && previousName.invalid" id="applicantPreviousNameError">
              {{ previousName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.surname as surname" class="standard-form-field surname-field required-field">
          <label for="applicantSurname" [class.invalid]="surname.touched && surname.invalid">
            {{ 'PERSONAL_DATA_FORM.SURNAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.SURNAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="surname.touched && surname.invalid ? 'true' : null"
              [attr.aria-describedby]="
                surname.touched && surname.invalid
                  ? 'applicantSurnameError applicantSurnameTooltip'
                  : 'applicantSurnameTooltip'
              "
              [formControl]="surname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.SURNAME.TOOLTIP' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="surname.touched && surname.invalid" id="applicantSurnameError">
              {{ surname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="controls.previousSurname as previousSurname" class="standard-form-field previousSurname-field">
          <label for="applicantPreviousSurname" [class.invalid]="previousSurname.touched && previousSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantPreviousSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.PREVIOUS-SURNAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="previousSurname.touched && previousSurname.invalid ? 'true' : null"
              [attr.aria-describedby]="
                previousSurname.touched && previousSurname.invalid
                  ? 'applicantPreviousSurnameError applicantPreviousSurnameTooltip'
                  : 'applicantPreviousSurnameTooltip'
              "
              [formControl]="previousSurname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantPreviousSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="previousSurname.touched && previousSurname.invalid" id="applicantPreviousSurnameError">
              {{ previousSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="nowrap-container">
        <div *ngIf="controls.familyName as familyName" class="standard-form-field familyName-field">
          <label for="applicantFamilyName" [class.invalid]="familyName.touched && familyName.invalid">
            {{ 'PERSONAL_DATA_FORM.FAMILY-NAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantFamilyName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.FAMILY-NAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="familyName.touched && familyName.invalid ? 'true' : null"
              [attr.aria-describedby]="
                familyName.touched && familyName.invalid
                  ? 'applicantFamilyNameError applicantFamilyNameTooltip'
                  : 'applicantFamilyNameTooltip'
              "
              [formControl]="familyName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantFamilyNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.FAMILY-NAME.TOOLTIP' | translate"
              [icon]="'help_outline'">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="familyName.touched && familyName.invalid" id="applicantFamilyNameError">
              {{ familyName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div *ngIf="controls.fatherName as fatherName" class="standard-form-field fatherName-field required-field">
          <label for="applicantFatherName" [class.invalid]="fatherName.touched && fatherName.invalid">
            {{ 'PERSONAL_DATA_FORM.FATHER-NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantFatherName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.FATHER-NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="fatherName.touched && fatherName.invalid ? 'true' : null"
              [attr.aria-describedby]="
                fatherName.touched && fatherName.invalid
                  ? 'applicantFatherNameError applicantFatherNameTooltip'
                  : 'applicantFatherNameTooltip'
              "
              [formControl]="fatherName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantFatherNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="fatherName.touched && fatherName.invalid" id="applicantFatherNameError">
              {{ fatherName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.fatherSurname as fatherSurname" class="standard-form-field fatherSurname-field">
          <label for="applicantFatherSurname" [class.invalid]="fatherSurname.touched && fatherSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.FATHER-SURNAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantFatherSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.FATHER-SURNAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="fatherSurname.touched && fatherSurname.invalid ? 'true' : null"
              [attr.aria-describedby]="
                fatherSurname.touched && fatherSurname.invalid
                  ? 'applicantFatherSurnameError applicantFatherSurnameTooltip'
                  : 'applicantFatherSurnameTooltip'
              "
              [formControl]="fatherSurname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantFatherSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="fatherSurname.touched && fatherSurname.invalid" id="applicantFatherSurnameError">
              {{ fatherSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.motherName as motherName" class="standard-form-field motherName-field required-field">
          <label for="applicantMotherName" [class.invalid]="motherName.touched && motherName.invalid">
            {{ 'PERSONAL_DATA_FORM.MOTHER-NAME.MAIN-LABEL' | translate }} <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantMotherName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.MOTHER-NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="motherName.touched && motherName.invalid ? 'true' : null"
              [attr.aria-describedby]="
                motherName.touched && motherName.invalid
                  ? 'applicantMotherNameError applicantMotherNameTooltip'
                  : 'applicantMotherNameTooltip'
              "
              [formControl]="motherName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantMotherNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="motherName.touched && motherName.invalid" id="applicantMotherNameError">
              {{ motherName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="nowrap-container">
        <div *ngIf="controls.motherSurname as motherSurname" class="standard-form-field motherSurname-field">
          <label for="applicantMotherSurname" [class.invalid]="motherSurname.touched && motherSurname.invalid">
            {{ 'PERSONAL_DATA_FORM.MOTHER-SURNAME.MAIN-LABEL' | translate }}
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantMotherSurname"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.MOTHER-SURNAME.PLACEHOLDER' | translate }}"
              [required]="false"
              [attr.aria-required]="false"
              [attr.aria-invalid]="motherSurname.touched && motherSurname.invalid ? 'true' : null"
              [attr.aria-describedby]="
                motherSurname.touched && motherSurname.invalid
                  ? 'applicantMotherSurnameError applicantMotherSurnameTooltip'
                  : 'applicantMotherSurnameTooltip'
              "
              [formControl]="motherSurname" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantMotherSurnameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="motherSurname.touched && motherSurname.invalid" id="applicantMotherSurnameError">
              {{ motherSurname.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>

        <div
          *ngIf="controls.motherMaidenName as motherMaidenName"
          class="standard-form-field motherMaidenName-field required-field">
          <label for="applicantMotherMaidenName" [class.invalid]="motherMaidenName.touched && motherMaidenName.invalid">
            {{ 'PERSONAL_DATA_FORM.MOTHER-MAIDEN-NAME.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantMotherMaidenName"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.MOTHER-MAIDEN-NAME.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="motherMaidenName.touched && motherMaidenName.invalid ? 'true' : null"
              [attr.aria-describedby]="
                motherMaidenName.touched && motherMaidenName.invalid
                  ? 'applicantMotherMaidenNameError applicantMotherMaidenNameTooltip'
                  : 'applicantMotherMaidenNameTooltip'
              "
              [formControl]="motherMaidenName" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantMotherMaidenNameTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.MOTHER-MAIDEN-NAME.TOOLTIP' | translate"
              [icon]="'help_outline'">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="motherMaidenName.touched && motherMaidenName.invalid" id="applicantMotherMaidenNameError">
              {{ motherMaidenName.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.sex as sex" class="standard-form-field sex-field required-field">
          <label [class.invalid]="sex.touched && sex.invalid">
            {{ 'PERSONAL_DATA_FORM.SEX.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <mat-select
              id="applicantSex"
              [formControl]="sex"
              placeholder="{{ 'PERSONAL_DATA_FORM.SEX.PLACEHOLDER' | translate }}"
              panelClass="standard-select"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="sex.touched && sex.invalid ? 'true' : null"
              [attr.aria-describedby]="sex.touched && sex.invalid ? 'applicantSexError' : null">
              <mat-option *ngFor="let item of selectsValues.SEX" [value]="item.value">
                {{ item.label }}
              </mat-option>
            </mat-select>

            <!-- ERROR -->
            <mat-error *ngIf="sex.touched && sex.invalid" id="applicantSexError">
              {{ sex.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div *ngIf="controls.dateOfBirth as dateOfBirth" class="standard-form-field dateOfBirth-field required-field">
          <label for="applicantDateOfBirth" [class.invalid]="dateOfBirth.touched && dateOfBirth.invalid">
            {{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline" (click)="picker.open()">
            <input
              matInput
              (focus)="picker.open()"
              id="applicantDateOfBirth"
              #applicantDateOfBirth
              [matDatepicker]="picker"
              placeholder="{{ 'PERSONAL_DATA_FORM.DATE-OF-BIRTH.PLACEHOLDER' | translate }}"
              [min]="minValidDate"
              [max]="maxValidDate"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="dateOfBirth.touched && dateOfBirth.invalid ? 'true' : null"
              [attr.aria-describedby]="dateOfBirth.touched && dateOfBirth.invalid ? 'applicantDateOfBirthError' : null"
              [readonly]="true"
              [formControl]="dateOfBirth" />

            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
              aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
            </mat-datepicker-toggle>

            <mat-datepicker
              #picker
              [startView]="'month'"
              [startAt]="'1985'"
              [calendarHeaderComponent]="pickerHeader"
              (closed)="applicantDateOfBirth.blur()">
            </mat-datepicker>

            <!-- ERROR -->
            <mat-error *ngIf="dateOfBirth.touched && dateOfBirth.invalid" id="applicantDateOfBirthError">
              {{ dateOfBirth.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="nowrap-container">
        <div
          *ngIf="controls.placeOfBirth as placeOfBirth"
          class="standard-form-field placeOfBirth-field required-field">
          <label for="applicantPlaceOfBirth" [class.invalid]="placeOfBirth.touched && placeOfBirth.invalid">
            {{ 'PERSONAL_DATA_FORM.PLACE-OF-BIRTH.MAIN-LABEL' | translate }}
            <span aria-hidden="true">&nbsp;*</span>
            <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
          </label>
          <mat-form-field appearance="outline">
            <input
              matInput
              id="applicantPlaceOfBirth"
              type="text"
              maxLength="200"
              minLength="1"
              placeholder="{{ 'PERSONAL_DATA_FORM.PLACE-OF-BIRTH.PLACEHOLDER' | translate }}"
              [required]="true"
              [attr.aria-required]="true"
              [attr.aria-invalid]="placeOfBirth.touched && placeOfBirth.invalid ? 'true' : null"
              [attr.aria-describedby]="
                placeOfBirth.touched && placeOfBirth.invalid
                  ? 'applicantPlaceOfBirthError applicantPlaceOfBirthTooltip'
                  : 'applicantPlaceOfBirthTooltip'
              "
              [formControl]="placeOfBirth" />

            <!-- TOOLTIP -->
            <app-cr-form-field-tooltip
              [id]="'applicantPlaceOfBirthTooltip'"
              class="info-suffix-icon"
              matSuffix
              [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
            </app-cr-form-field-tooltip>

            <!-- ERROR -->
            <mat-error *ngIf="placeOfBirth.touched && placeOfBirth.invalid" id="applicantPlaceOfBirthError">
              {{ placeOfBirth.errors | errorsFormatingAndTranslate }}
            </mat-error>
          </mat-form-field>
        </div>
        <div
          *ngIf="controls.countryOfBirth as countryOfBirth"
          class="standard-form-field countryOfBirth-field required-field">
          <app-country-select
            class="country-select"
            [fieldControl]="countryOfBirth"
            [fieldKey]="'countryOfBirth'"
            [isRequired]="true"
            [fieldLabelKey]="'COUNTRY-OF-BIRTH'">
          </app-country-select>
        </div>
      </div>
      <div class="nowrap-container">
        <div *ngIf="controls.citizenship as citizenship" class="standard-form-field citizenship-field required-field">
          <!-- Filtering out id: 616 -> Poland. Person that has Polish citizenship cannot apply for temp. permit -->
          <app-country-select
            class="country-select"
            [fieldControl]="citizenship"
            [fieldKey]="'citizenship'"
            [isRequired]="true"
            [filterOutIds]="[616]"
            [fieldLabelKey]="'CITIZENSHIP'">
          </app-country-select>
        </div>
        <div *ngIf="controls.nationality as nationality" class="standard-form-field nationality-field required-field">
          <app-nationality-select
            class="country-select"
            [fieldControl]="nationality"
            [fieldKey]="'nationality'"
            [isRequired]="true"
            [fieldLabelKey]="'NATIONALITY'">
          </app-nationality-select>
        </div>
      </div>
      <div class="row">
        <div class="nowrap-container">
          <div
            *ngIf="controls.maritalStatus as maritalStatus"
            class="standard-form-field maritalStatus-field required-field">
            <label [class.invalid]="maritalStatus.touched && maritalStatus.invalid">
              {{ 'PERSONAL_DATA_FORM.MARITAL-STATUS.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="applicantMaritalStatus"
                placeholder="{{ 'PERSONAL_DATA_FORM.MARITAL-STATUS.PLACEHOLDER' | translate }}"
                [formControl]="maritalStatus"
                panelClass="standard-select"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="maritalStatus.touched && maritalStatus.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  maritalStatus.touched && maritalStatus.invalid ? 'applicantMaritalStatusError' : null
                ">
                <mat-option *ngFor="let item of selectsValues.MARITAL_STATUS" [value]="item.value">
                  {{ item.label }}
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error *ngIf="maritalStatus.touched && maritalStatus.invalid" id="applicantMaritalStatusError">
                {{ maritalStatus.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="controls.education as education" class="standard-form-field education-field required-field">
            <label [class.invalid]="controls.education.touched && controls.education.invalid">
              {{ 'PERSONAL_DATA_FORM.EDUCATION.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <mat-select
                id="applicantEducation"
                placeholder="{{ 'PERSONAL_DATA_FORM.EDUCATION.PLACEHOLDER' | translate }}"
                [formControl]="education"
                panelClass="standard-select"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="education.touched && education.invalid ? 'true' : null"
                [attr.aria-describedby]="education.touched && education.invalid ? 'applicantEducationError' : null">
                <mat-option *ngFor="let item of selectsValues.EDUCATION" [value]="item.value">
                  {{ item.label }}
                </mat-option>
              </mat-select>

              <!-- ERROR -->
              <mat-error *ngIf="education.touched && education.invalid" id="applicantEducationError">
                {{ education.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="nowrap-container">
          <div
            *ngIf="controls.passportNumber as passportNumber"
            class="standard-form-field passportNumber-field required-field">
            <label for="applicantPassportNumber" [class.invalid]="passportNumber.touched && passportNumber.invalid">
              {{ 'PERSONAL_DATA_FORM.PASSPORT-NUMBER.MAIN-LABEL' | translate }}
              <span aria-hidden="true">&nbsp;*</span>
              <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                id="applicantPassportNumber"
                type="text"
                maxLength="200"
                minLength="1"
                placeholder="{{ 'PERSONAL_DATA_FORM.PASSPORT-NUMBER.PLACEHOLDER' | translate }}"
                [required]="true"
                [attr.aria-required]="true"
                [attr.aria-invalid]="passportNumber.touched && passportNumber.invalid ? 'true' : null"
                [attr.aria-describedby]="
                  passportNumber.touched && passportNumber.invalid
                    ? 'applicantPassportNumberError applicantPassportNumberTooltip'
                    : 'applicantPassportNumberTooltip'
                "
                [formControl]="passportNumber" />

              <!-- TOOLTIP -->
              <app-cr-form-field-tooltip
                [id]="'applicantPassportNumberTooltip'"
                class="info-suffix-icon"
                matSuffix
                [text]="'PERSONAL_DATA_FORM.USE_ONLY_LATIN' | translate">
              </app-cr-form-field-tooltip>

              <!-- ERROR -->
              <mat-error *ngIf="passportNumber.touched && passportNumber.invalid" id="applicantPassportNumberError">
                {{ passportNumber.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div *ngIf="controls.pesel as pesel" class="standard-form-field pesel-field">
            <label for="peselInput" [class.invalid]="pesel.touched && pesel.invalid">
              {{ 'PERSONAL_DATA_FORM.PESEL.INFIELD-LABEL' | translate }}
            </label>
            <mat-form-field appearance="outline">
              <input
                matInput
                #peselInput
                id="peselInput"
                placeholder="{{ 'PERSONAL_DATA_FORM.PESEL.PLACEHOLDER' | translate }}"
                [required]="false"
                [attr.aria-required]="false"
                [attr.aria-invalid]="pesel.touched && pesel.invalid ? 'true' : null"
                [attr.aria-describedby]="pesel.touched && pesel.invalid ? 'applicantPeselError' : null"
                formControlName="pesel" />

              <!-- ERROR -->
              <mat-error *ngIf="pesel.touched && pesel.invalid" id="applicantPeselError">
                {{ pesel.errors | errorsFormatingAndTranslate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <nz-divider [nzText]="travelers" nzOrientation="center">
      <ng-template #travelers>
        <h5>{{ 'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT' | translate }}</h5>
      </ng-template>
    </nz-divider>

    <div class="row">
      <div
        *ngIf="controls.travelDocumentType as travelDocumentType"
        class="standard-form-field widened-field travelDocumentType-field required-field">
        <label for="travelDocumentType" [class.invalid]="travelDocumentType.touched && travelDocumentType.invalid">
          {{ 'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT_TYPE.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <mat-select
            id="travelDocumentType"
            placeholder="{{ 'PERSONAL_DATA_FORM.TRAVEL_DOCUMENT_TYPE.PLACEHOLDER' | translate }}"
            [formControl]="travelDocumentType"
            panelClass="standard-select"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="travelDocumentType.touched && travelDocumentType.invalid ? 'true' : null"
            [attr.aria-describedby]="
              travelDocumentType.touched && travelDocumentType.invalid ? 'applicantTravelDocumentTypeError' : null
            ">
            <mat-option *ngFor="let item of travelDocumentTypes" [value]="item">
              {{ 'COMMON.TRAVEL_DOCUMENT_TYPES.' + item | translate }}
            </mat-option>
          </mat-select>

          <!-- ERROR -->
          <mat-error
            *ngIf="travelDocumentType.touched && travelDocumentType.invalid"
            id="applicantTravelDocumentTypeError">
            {{ travelDocumentType.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="row">
      <div
        *ngIf="controls.travelDocumentSeries as travelDocumentSeries"
        class="standard-form-field travelDocumentSeries-field required-field">
        <label
          for="travelDocumentSeriesInput"
          [class.invalid]="travelDocumentSeries.touched && travelDocumentSeries.invalid">
          {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-SERIES.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            id="travelDocumentSeriesInput"
            placeholder="{{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-SERIES.PLACEHOLDER' | translate }}"
            matInput
            type="text"
            maxLength="2"
            minLength="1"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="travelDocumentSeries.touched && travelDocumentSeries.invalid ? 'true' : null"
            [attr.aria-describedby]="
              travelDocumentSeries.touched && travelDocumentSeries.invalid ? 'applicantTravelDocumentSeriesError' : null
            "
            [formControl]="travelDocumentSeries" />

          <!-- ERROR -->
          <mat-error
            *ngIf="travelDocumentSeries.touched && travelDocumentSeries.invalid"
            id="applicantTravelDocumentSeriesError">
            {{ travelDocumentSeries.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div
        *ngIf="controls.travelDocumentNumber as travelDocumentNumber"
        class="standard-form-field travelDocumentNumber-field required-field">
        <label
          for="travelDocumentNumberInput"
          [class.invalid]="travelDocumentNumber.touched && travelDocumentNumber.invalid">
          {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NUMBER.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            id="travelDocumentNumberInput"
            placeholder="{{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NUMBER.PLACEHOLDER' | translate }}"
            matInput
            type="text"
            maxLength="100"
            minLength="1"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="travelDocumentNumber.touched && travelDocumentNumber.invalid ? 'true' : null"
            [attr.aria-describedby]="
              travelDocumentNumber.touched && travelDocumentNumber.invalid ? 'applicantTravelDocumentNumberError' : null
            "
            [formControl]="travelDocumentNumber" />

          <!-- ERROR -->
          <mat-error
            *ngIf="travelDocumentNumber.touched && travelDocumentNumber.invalid"
            id="applicantTravelDocumentNumberError">
            {{ travelDocumentNumber.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div
        *ngIf="controls.travelDocumentNrOfPersonsEntered as travelDocumentNrOfPersonsEntered"
        class="standard-form-field widened-field travelDocumentNrOfPersonsEntered-field required-field">
        <label
          for="travelDocumentNrOfPersonsEnteredInput"
          [class.invalid]="travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid">
          {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NR-OF-PERSONS-ENTERED.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            id="travelDocumentNrOfPersonsEnteredInput"
            placeholder="{{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-NR-OF-PERSONS-ENTERED.PLACEHOLDER' | translate }}"
            matInput
            type="number"
            max="20"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="
              travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid ? 'true' : null
            "
            [attr.aria-describedby]="
              travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid
                ? 'travelDocumentNrOfPersonsEnteredError'
                : null
            "
            [formControl]="travelDocumentNrOfPersonsEntered" />

          <!-- ERROR -->
          <mat-error
            *ngIf="travelDocumentNrOfPersonsEntered.touched && travelDocumentNrOfPersonsEntered.invalid"
            id="travelDocumentNrOfPersonsEnteredError">
            {{ travelDocumentNrOfPersonsEntered.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div
        *ngIf="controls.travelDocumentIssueDate as travelDocumentIssueDate"
        class="standard-form-field travelDocumentIssueDate-field required-field">
        <label
          for="travelDocumentIssueDateInput"
          [class.invalid]="travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid">
          {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUE-DATE.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline" (click)="travelDocumentIssueDatePicker.open()">
          <input
            id="travelDocumentIssueDateInput"
            placeholder="{{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUE-DATE.PLACEHOLDER' | translate }}"
            matInput
            (focus)="travelDocumentIssueDatePicker.open()"
            #applicantIssueDate
            [matDatepicker]="travelDocumentIssueDatePicker"
            [min]="minValidDate"
            [max]="maxValidDate"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid ? 'true' : null"
            [attr.aria-describedby]="
              travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid
                ? 'travelDocumentIssueDateInputError'
                : null
            "
            [readonly]="true"
            [formControl]="travelDocumentIssueDate" />

          <mat-datepicker-toggle
            matSuffix
            [for]="travelDocumentIssueDatePicker"
            aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
          </mat-datepicker-toggle>

          <mat-datepicker
            #travelDocumentIssueDatePicker
            [startView]="'month'"
            [startAt]="'1985'"
            [calendarHeaderComponent]="pickerHeader"
            (closed)="applicantIssueDate.blur()">
          </mat-datepicker>

          <!-- ERROR -->
          <mat-error
            *ngIf="travelDocumentIssueDate.touched && travelDocumentIssueDate.invalid"
            id="travelDocumentIssueDateInputError">
            {{ travelDocumentIssueDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        *ngIf="controls.travelDocumentExpiryDate as travelDocumentExpiryDate"
        class="standard-form-field travelDocumentExpiryDate-field required-field">
        <label
          for="travelDocumentExpiryDateInput"
          [class.invalid]="travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid">
          {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-EXPIRY-DATE.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline" (click)="travelDocumentExpiryDatePicker.open()">
          <input
            id="travelDocumentExpiryDateInput"
            placeholder="{{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-EXPIRY-DATE.PLACEHOLDER' | translate }}"
            matInput
            (focus)="travelDocumentExpiryDatePicker.open()"
            #applicantExpiryDate
            [matDatepicker]="travelDocumentExpiryDatePicker"
            [min]="minValidDate"
            [max]="maxValidFutureDate"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid ? 'true' : null"
            [attr.aria-describedby]="
              travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid
                ? 'travelDocumentExpiryDateError'
                : null
            "
            [readonly]="true"
            [formControl]="travelDocumentExpiryDate" />

          <mat-datepicker-toggle
            matSuffix
            [for]="travelDocumentExpiryDatePicker"
            aria-label="{{ 'COMMON.ACTION.OPEN_DATE_PICKER' | translate }}">
          </mat-datepicker-toggle>

          <mat-datepicker
            #travelDocumentExpiryDatePicker
            [startView]="'month'"
            [startAt]="'1985'"
            [calendarHeaderComponent]="pickerHeader"
            (closed)="applicantExpiryDate.blur()">
          </mat-datepicker>

          <!-- ERROR -->
          <mat-error
            *ngIf="travelDocumentExpiryDate.touched && travelDocumentExpiryDate.invalid"
            id="travelDocumentExpiryDateError">
            {{ travelDocumentExpiryDate.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>

      <div
        *ngIf="controls.travelDocumentIssuingAuthority as travelDocumentIssuingAuthority"
        class="standard-form-field widened-field travelDocumentIssuingAuthority-field required-field">
        <label
          for="travelDocumentIssuingAuthorityInput"
          [class.invalid]="travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid">
          {{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUING-AUTHORITY.MAIN-LABEL' | translate }}
          <span aria-hidden="true">&nbsp;*</span>
          <span class="sr-only">{{ 'COMMON.LABEL.FIELD_IS_REQUIRED' | translate }}</span>
        </label>
        <mat-form-field appearance="outline">
          <input
            id="travelDocumentIssuingAuthorityInput"
            placeholder="{{ 'PERSONAL_DATA_FORM.TRAVEL-DOCUMENT-ISSUING-AUTHORITY.PLACEHOLDER' | translate }}"
            matInput
            type="text"
            maxLength="100"
            [required]="true"
            [attr.aria-required]="true"
            [attr.aria-invalid]="
              travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid ? 'true' : null
            "
            [attr.aria-describedby]="
              travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid
                ? 'travelDocumentIssuingAuthorityError'
                : null
            "
            [formControl]="travelDocumentIssuingAuthority"
            (keydown.Tab)="lastFieldTabPressed.emit(); $event.preventDefault(); $event.stopPropagation()" />

          <!-- ERROR -->
          <mat-error
            *ngIf="travelDocumentIssuingAuthority.touched && travelDocumentIssuingAuthority.invalid"
            id="travelDocumentIssuingAuthorityError">
            {{ travelDocumentIssuingAuthority.errors | errorsFormatingAndTranslate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
